export const joinRemotePath = (base, name) => {
  if (!base || base === '/') return `/${name}`;
  return `${base.replace(/\/+$/, '')}/${name}`;
};

export const remoteParent = (current) => {
  if (!current || current === '/') return '/';
  const trimmed = current.replace(/\/+$/, '');
  const idx = trimmed.lastIndexOf('/');
  if (idx <= 0) return '/';
  return trimmed.slice(0, idx);
};

export const joinLocalPath = (base, name) => {
  const sep = base.includes('\\') ? '\\' : '/';
  if (!base) return name;
  if (base.endsWith(sep)) return `${base}${name}`;
  return `${base}${sep}${name}`;
};

export const localParent = (current) => {
  if (!current) return '';
  const trimmed = current.replace(/[\\/]+$/, '');
  const idx = Math.max(trimmed.lastIndexOf('\\'), trimmed.lastIndexOf('/'));
  if (idx <= 0) return trimmed;
  const parsedRoot = trimmed.match(/^[A-Za-z]:[\\/]/);
  if (parsedRoot && idx <= parsedRoot[0].length) return parsedRoot[0];
  return trimmed.slice(0, idx);
};

export const formatSize = (size) => {
  if (size === null || size === undefined) return '--';
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  return `${(size / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};

export const formatDate = (value) => {
  if (!value) return '--';
  return new Date(value).toLocaleString();
};